import React, { useState ,useEffect} from 'react';
import apiService from '../Services/apiService';
import { Link, useNavigate } from "react-router-dom";
import '../styles/LoginCss.css';
import TruveyGreenLogo from '../Asset/Images/XSO-White.png';
import  UpperFooter from '../Component/UpperFooter';
const SignUp = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        password: '',
        confirmPassword: '',
        emailOTP: '',
        isTermsChecked: false,
    });
    const [errors, setErrors] = useState({});
    const [responseErrors, setResponseErrors] = useState("");
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [enterOtp, setenterOtp] = useState("");
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [captcha, setCaptcha] = useState("");
    const [input, setInput] = useState("");
    const Redirect=useNavigate();
    useEffect(() => {
        const token = localStorage.getItem("JWTToken");
        if (token) {
            Redirect("/SurveyList")
        } else {
            generateCaptcha();
          setIsLoggedIn(false);
        }
      }, []);
      
    const handleInputChange = (e) => {
        const { id, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: type === "checkbox" ? checked : value,
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const mobilePattern = /^[6-9]\d{9}$/;
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/;

        // Validate Name
        if (!formData.name.trim()) {
            newErrors.name = "Name is required";
        } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
            newErrors.name = "Name can only contain letters";
        }
        
        // Validate Email
        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else if (!emailPattern.test(formData.email)) {
            newErrors.email = 'Please enter a valid email';
        }

        // Validate Mobile Number
        if (!formData.mobile) {
            newErrors.mobile = 'Mobile number is required';
        } else if (!mobilePattern.test(formData.mobile)) {
            newErrors.mobile = 'Please enter a valid Indian mobile number';
        }

        // Validate Password
        if (!formData.password) {
            newErrors.password = 'Password is required';
        } else if (!passwordPattern.test(formData.password)) {
            newErrors.password =
                'Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and be at least 8 characters long.';
        }

        // Validate Confirm Password
        if (!formData.confirmPassword) {
            newErrors.confirmPassword = 'Confirm Password is required';
        } else if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match';
        }

        // Validate Terms Checkbox
        if (!formData.isTermsChecked) {
            newErrors.isTermsChecked = "You must agree to the terms and conditions.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSignUp = async (e) => {
        e.preventDefault();
        if(captcha!==input){
                alert("please enter correct captcha");
                return;
        }
        if (validateForm()) {
            try {
                const response = await apiService.RegisterUser(
                    formData.name,
                    formData.email,
                    formData.mobile,
                    formData.password
                );
                if (response) {
                    setResponseErrors(response.Message);
                    if (response.Code == 200) {
                        setIsFormSubmitted(true);
                    }
                } else {
                    console.log('Form Submitted Successfully');
                }
            } catch (error) {
                console.error("Error during signup:", error);
            }
        }
    };

    const togglePasswordVisibility = () => {
        setIsPasswordVisible((prev) => !prev);
    };
    const VerifyUser = async () => {
        try {
            if (enterOtp) {
                const response = await apiService.VerifyRegisterUser(formData.name, formData.email, enterOtp);
                if (response) {
                    alert(response.MESSAGE);
                    Redirect("/Login")
                }
            } else {
                alert("please enter otp");
            }

        } catch (error) {
            throw error
        }
    }

    const generateCaptcha = () => {
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        for (let i = 0; i < 6; i++) {
          result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        setCaptcha(result);
      };
    return (
        <>
        <section className="TruveyBG min-hight99vh py-5">
            <div className="container">
                <div className="row d-flex align-items-center justify-content-center h-100">
                    <div className="col-md-7 col-lg-6 col-xl-5">
                        <div className="d-none d-md-block text-center" style={{ width: "100%" }}>
                            <Link to="/" className='d-block w-100'>
                                <img src={TruveyGreenLogo} alt="Logo" className='w-50'/>
                            </Link>
                        </div>
                    </div>
                    <div
                        className="col-md-5 col-lg-6 col-xl-6 offset-xl-1 p-3 bg-white"
                        style={{
                            borderRadius: "1rem",
                            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        }}
                    >
                            <div className="p-5">
                                <h2 className="text-center fw-bold mb-4">Sign Up</h2>
                           {!isFormSubmitted ? (<>
                                <form>
                                    <div className="row">
                                        <div className="form-group col-md-6 col-12">
                                            <label htmlFor="name" className="form-label">Name</label>
                                            <span className="text-danger">*</span>
                                            <input
                                                type="text"
                                                id="name"
                                                className="form-control mb-2 text-capitlize"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                            />
                                            {errors.name && <span className="text-danger">{errors.name}</span>}
                                        </div>

                                        <div className="form-group col-md-6 col-12">
                                            <label htmlFor="email" className="form-label">Email</label>
                                            <span className="text-danger">*</span>
                                            <input
                                                type="email"
                                                id="email"
                                                className="form-control mb-2"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                            />
                                            {errors.email && <span className="text-danger">{errors.email}</span>}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="mobile" className="form-label">Mobile Number</label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group rounded-pill mb-2">
                                            <span className="input-group-text border-0">+91</span>
                                            <input
                                                type="tel"
                                                id="mobile"
                                                className="form-control"
                                                value={formData.mobile}
                                                onChange={handleInputChange}
                                                maxLength={10}
                                            />
                                        </div>
                                        {errors.mobile && <span className="text-danger">{errors.mobile}</span>}
                                    </div>

                                    <div className="row">
                                        <div className="form-group col-md-6 col-12">
                                            <label htmlFor="password" className="form-label">Password</label>
                                            <span className="text-danger">*</span>
                                            <input
                                                type={isPasswordVisible ? 'text' : 'password'}
                                                id="password"
                                                className="form-control mb-2"
                                                value={formData.password}
                                                onChange={handleInputChange}
                                            />
                                            {errors.password && <span className="text-danger">{errors.password}</span>}
                                        </div>

                                        <div className="form-group col-md-6 col-12">
                                            <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                                            <span className="text-danger">*</span>
                                            <div className="input-group">
                                                <input
                                                    type={isPasswordVisible ? 'text' : 'password'}
                                                    id="confirmPassword"
                                                    className="form-control rounded-2"
                                                    value={formData.confirmPassword}
                                                    onChange={handleInputChange}
                                                />
                                                <button
                                                    className="btn btn-custom col-1"
                                                    type="button"
                                                    onClick={togglePasswordVisibility}
                                                >
                                                    <span className="bi bi-eye"></span>
                                                </button>
                                            </div>
                                            {errors.confirmPassword && <span className="text-danger">{errors.confirmPassword}</span>}
                                        </div>
                                    </div>

                                    <div className="form-group mt-2">
                                        <label htmlFor="confirmPassword" className="form-label">Captcha:</label>
                                        <div className='mb-2'>
                                            <span className='CaptchaValue'>{captcha}</span>
                                            <button onClick={generateCaptcha} className='btn'><i className="fa-solid fa-arrows-rotate"></i></button>
                                        </div>
                                        <input
                                            type="text"
                                            value={input}
                                            className='form-control rounded-2'
                                            placeholder="Enter the captcha"
                                            onChange={(e) => setInput(e.target.value)}
                                            required
                                        />

                                    </div>

                                    <div className="form-group mt-2">
                                        <input
                                            type="checkbox"
                                            id="isTermsChecked"
                                            className="me-2"
                                            checked={formData.isTermsChecked}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor="isTermsChecked" className="form-check-label">
                                            I agree to the <Link to="/TermsAndCondtion" target='_blank'>terms and conditions</Link> and <Link to="/PrivacyPolicy" target='_blank'>privacy policy</Link>.
                                        </label>
                                        {errors.isTermsChecked && <div className="text-danger">{errors.isTermsChecked}</div>}
                                    </div>


                                    <div className="mt-2">
                                        <label htmlFor="" className="text-danger">{responseErrors}</label>
                                    </div>
                                    <button type="submit" className="btn btn-custom btn-lg btn-block form-control mt-4 mb-4" onClick={handleSignUp}>Sign Up</button>
                                </form>
                        </>) :
                            (<>
                                <div>
                                    <div className="form-group">
                                        <label htmlFor="mobile" className="form-label">Enter Email OTP</label>
                                        <span className="text-danger">*</span>
                                        <div className="mb-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={enterOtp}
                                                onChange={(e) => setenterOtp(e.target.value)}
                                            />
                                        </div>
                                    <button type="submit" className="btn btn-custom btn-lg btn-block form-control mt-4 mb-4" onClick={(e)=>{e.preventDefault();VerifyUser();}}>Sign Up</button>

                                        {/* {errors.mobile && <span className="text-danger">{errors.mobile}</span>} */}
                                    </div>
                                </div>
                            </>)}
                            <div className="d-flex justify-content-around align-items-center mt-2 mb-4">
                                    <p><Link to="/ForgetPassword">Forgot password?</Link></p>
                                    <p>Already have an account? <Link to="/Login">Login</Link></p>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </section>
            <UpperFooter />
        </>

    );
};

export default SignUp;
